
















import Vue from 'vue';
import Component from 'vue-class-component';
import * as ent from '@/entities';
import newsApi from '@/api/news.api';
import { NoteType } from '@/entities/note/note.type';
import * as types from '@/store/types';
import { INote } from '@/entities/note/note.interface';
import * as utils from '@/utils';

@Component({})
export default class NewsEdit extends Vue {
    public parentPath: string = '/app/home';

    public html: string = null;
    public loading: boolean = false;

    public created() {
        this._loadNews();
    }

    public async submit(body: any) {
        this.loading = true;
        try {
            await newsApi.update({
                html: this.html
            });
            this.notify();
            this.$router.push(this.parentPath);
        } finally {
            this.loading = false;
        }
    }

    private notify() {
        let payload: INote = {
            total: 1,
            guid: utils.guid(),
            type: NoteType.Success,
            heading: 'Success',
            body: 'Successfully saved'
        };
        this.$store.dispatch(types.ADD_TEMP_NOTE, payload);
    }

    private async _loadNews() {
        this.loading = true;
        try {
            const lastNews = await newsApi.lastNews();
            this.html = lastNews ? lastNews.html : '';
        } finally {
            this.loading = false;
        }
    }
}
